import { axios } from '../../../plugins/axios'

const BASE_PATH = '/PoliciaCuadrantes/DesarrolloPolicial'

export default class RendimientoProfesionalismoApiRepository {
  async create(payload, idPersonal) {
    const { data } = await axios.post(BASE_PATH + '/personal/' + idPersonal + '/rendimientoProfesionalismo', payload)

    return data
  }

  async update(payload, idPersonal, idEvaluacion) {
    const { data } = await axios.put(
      BASE_PATH + '/personal/' + idPersonal + '/rendimientoProfesionalismo/' + idEvaluacion,
      payload
    )

    return data
  }

  async updateEstatus(payload, idPersonal, idEvaluacion) {
    const { data } = await axios.put(
      BASE_PATH + '/personal/' + idPersonal + '/rendimientoProfesionalismo/' + idEvaluacion + '/estatus',
      {
        fk_idCatEstatusEvaluacion: payload.fk_idCatEstatusEvaluacion,
      }
    )

    return data
  }

  async findById(payload) {
    const { data } = await axios.get(
      BASE_PATH + '/personal/' + payload.idPersonal + '/rendimientoProfesionalismo/' + payload.idEvaluacion
    )

    return data.data
  }

  async getEvaluationItems() {
    const { data } = await axios.get(BASE_PATH + '/evaluacion/5/reactivosEvaluacion')

    return data.data
  }
}
